import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityDetectedApplicationById } from '@api/data-security';

export const getCoreDataSecurityDetectedApplicationsByIdSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityDetectedApplicationsById',
	receive: true,
	request: true,
	requestHandler: getDataSecurityDetectedApplicationById,
	retainDataOnRequest: true
});
